import { render, staticRenderFns } from "./CoachSideNav.vue?vue&type=template&id=bd943a66&scoped=true&"
import script from "./CoachSideNav.vue?vue&type=script&lang=ts&"
export * from "./CoachSideNav.vue?vue&type=script&lang=ts&"
import style0 from "./CoachSideNav.vue?vue&type=style&index=0&id=bd943a66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd943a66",
  null
  
)

export default component.exports